import { SVGProps } from "react";

export function ExpiredRedIcon({
    stroke = "#667085",
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_23193_152317)">
                <path d="M8.5 0C6.12187 0 3.99062 1.04375 2.52813 2.69375L0.5 0.665625V6H5.83437L3.95312 4.11875C5.05 2.82812 6.67188 2 8.5 2C11.8125 2 14.5 4.68437 14.5 8C14.5 11.3156 11.8125 14 8.5 14C6.84375 14 5.34375 13.3281 4.25625 12.2437L2.84375 13.6562C4.29375 15.1031 6.29375 16 8.5 16C12.9187 16 16.5 12.4187 16.5 8C16.5 3.58125 12.9187 0 8.5 0ZM7.83437 3.33437V8.66875H11.8344V7.33437H9.16875V3.33437H7.83437Z" fill="#F04438" />
            </g>
            <defs>
                <clipPath id="clip0_23193_152317">
                    <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
            </defs>
        </svg>

    );
}
export function ExpiredGreenIcon({
    stroke = "#667085",
    xmlns = "http://www.w3.org/2000/svg",
    ...props
}: SVGProps<SVGSVGElement>) {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_23193_156055)">
                <path d="M8 0C5.62187 0 3.49062 1.04375 2.02813 2.69375L0 0.665625V6H5.33437L3.45312 4.11875C4.55 2.82812 6.17188 2 8 2C11.3125 2 14 4.68437 14 8C14 11.3156 11.3125 14 8 14C6.34375 14 4.84375 13.3281 3.75625 12.2437L2.34375 13.6562C3.79375 15.1031 5.79375 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0ZM7.33437 3.33437V8.66875H11.3344V7.33437H8.66875V3.33437H7.33437Z" fill="#008934" />
            </g>
            <defs>
                <clipPath id="clip0_23193_156055">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
}